import { Direction, State } from './types';
import {
  consumeDeltaSubtract,
  getNewValue,
  setStyles,
  updateStateWithNewValue,
} from './utils';

export const reduceMousePosition = (
  state: State,
  mousePoition: { x: number; y: number }
): State => {
  const delta =
    state.direction === Direction.HORIZONTAL
      ? mousePoition.x - state.startState.x
      : mousePoition.y - state.startState.y;
  return setStyles(processDelta(delta, state));
};

const processDelta = (delta: number, state: State) => {
  const { configs } = state;
  if (delta === 0) return state;
  let configIndex = state.activeResizerIndex + (delta > 0 ? 0 : 1);
  const nextConfigIndex = configIndex + (delta > 0 ? 1 : -1);
  while (configs[configIndex] && configs[configIndex].isCollapsed) {
    configIndex += delta > 0 ? -1 : 1;
  }
  if (configs[configIndex] && configs[nextConfigIndex]) {
    const [newState] = consumeDeltaSubtract(delta, nextConfigIndex, state);
    const newValue = getNewValue(newState, configIndex);
    return updateStateWithNewValue(newState, configIndex, newValue);
  }
  return state;
};
